import React from 'react';
import $ from '../../common/AjaxRequest';
import { Button, DatePicker } from 'antd';
import SideNav from './SideNav';
import API_URL from '../../common/url';
import Highcharts from 'react-highcharts';
import chartsConfig from '../common/chartsConfig';
import ExportUtil from '../../common/ExportUtil';
import moment from 'moment';

const { MonthPicker } = DatePicker;
const monthFormat = 'YYYY-MM';

class StandardVisitHourCompare extends React.Component {
    state = {
        invList: [],
        siteList: [],
        searchParams: {},
    }

    componentDidMount() {
        this.setState({
            searchParams: {
                date: moment().format(monthFormat),
            },
        }, () => {
            this.loadData();
        });
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG', 'label',
        ];
        chartsConfig.exporting.menuItemDefinitions.label = {
            onclick: () => {
                const { searchParams } = this.state;
                let url = API_URL.home.exportSitePerVisitFteList;
                ExportUtil.export({ ...searchParams }, null, url);
            },
            text: '导出Excel'
        }
    }

    loadData = () => {
        const { searchParams } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.home.querySitePerVisitFteList,
            data: { ...searchParams },
            dateType: 'json',
            doneResult: res => {
                const { invList= [], siteList= [] } = res;
                this.setState({
                    invList,
                    siteList,
                });
            }
        }
        $.sendRequest(options);
    }

    handleDateChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    getChartConfig = () => {
        const { invList, siteList } = this.state;
        let list = [];
        let columnName = '中心月标访工时数';
        let splineName = '项目月标访工时数';
        let splineList = [];
        let columnList = [];
        siteList.forEach(el => {
            list.push(el.investigationSiteCode);
            columnList.push(el.fteVisitRate);
        });
        invList.forEach(el => {
            splineList.push(el.fteVisitRate);
        });
        
        return {
            title: {
                text: ''
            },
            chart: {
                type: 'line'
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 20,
                layout: 'vertical',
            },
            yAxis: {
                title: {
                    text: ''
                },
            },
            xAxis: {
                categories: list,
            },
            series: [{
                type: 'column',
                name: columnName,
                data: columnList,
            }, {
                type: 'spline',
                name: splineName,
                data: splineList,
            }],
            exporting: {
                chartOptions: {
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            credits: {
                enabled: false,
            },
        };
    }

    render() {
        const { searchParams: { date } } = this.state;
        return (
            <div className="content primary-tabs-active">
                <SideNav selectKey='/summary/standardVisitHourCompare' />
                <div className="main">
                    <div className="T-tit">
                        <div className="txt">
                            <h3 style={{ marginBottom: 10 }}>各中心标访工时数对比</h3>
                        </div>
                    </div>
                    <div style={{ marginBottom: 20 }}>
                        日期：
                        <MonthPicker
                            format={monthFormat}
                            value={date ? moment(date) : null}
                            allowClear={false}
                            placeholder="请选择"
                            style={{ width: 120 }}
                            onChange={(date, dateString) => this.handleDateChange(dateString, 'date')}
                        />
                        <Button type='primary' style={{ marginLeft: 10 }} onClick={this.loadData}>统计</Button>
                    </div>
                    <div className="charts" style={{ marginBottom: 10 }}>
                        <Highcharts config={{ ...this.getChartConfig(), ...chartsConfig }} />
                    </div>
                </div>
            </div>
        );
    }
}

export default StandardVisitHourCompare;


// WEBPACK FOOTER //
// ./src/components/summary/StandardVisitHourCompare.js